import { store } from "react-notifications-component";

export const successNotification = {
  title: "Success!",
  message: "",
  type: "success",
  insert: "top",
  container: "top-center",
  animationIn: ["animated", "flipInY"],
  animationOut: ["animated", "bounceOut"],
  dismiss: {
    duration: 10000,
    onScreen: false,
    showIcon: true,
  },
};

export const warningNotification = {
  title: "Warning!",
  message: "",
  type: "warning",
  insert: "top",
  container: "top-center",
  animationIn: ["animated", "flipInY"],
  animationOut: ["animated", "bounceOut"],
  dismiss: {
    duration: 10000,
    onScreen: false,
    showIcon: true,
  },
};

export const infoNotification = {
  title: "Info!",
  message: "",
  type: "info",
  insert: "top",
  container: "top-center",
  animationIn: ["animated", "flipInY"],
  animationOut: ["animated", "bounceOut"],
  dismiss: {
    duration: 10000,
    onScreen: false,
    showIcon: true,
  },
};

export const infoNotification1 = {
  title: "",
  message: "",
  // type: "warning",
  type: "info",
  insert: "top",
  container: "top-center",
  animationIn: ["animated", "flipInY"],
  animationOut: ["animated", "bounceOut"],
  dismiss: {
    duration: 16000,
    onScreen: false,
    showIcon: true,
  },
};

export const infoNotification2 = {
  title: "Info!",
  message: "",
  // type: "warning",
  type: "info",
  insert: "top",
  container: "top-center",
  animationIn: ["animated", "flipInY"],
  animationOut: ["animated", "bounceOut"],
  dismiss: {
    duration: 16000,
    onScreen: false,
    showIcon: true,
  },
};
export const infoNotification3 = {
  title: "Info!",
  message: "",
  // type: "warning",
  type: "info",
  insert: "top",
  container: "top-center",
  animationIn: ["animated", "flipInY"],
  animationOut: ["animated", "bounceOut"],
  dismiss: {
    duration: 16000,
    onScreen: false,
    showIcon: true,
  },
};
export const infoNotification4 = {
  title: "Deployment Info!",
  message: "",
  type: "info",
  insert: "top",
  container: "top-center",
  animationIn: ["animated", "flipInY"],
  animationOut: ["animated", "bounceOut"],
  dismiss: {
    duration: 10000,
    onScreen: true,
    showIcon: true,
  },
  backgroundColor: "lightblue",
  icon: "deployment-icon",
};

export const errorNotification = {
  title: "Error!",
  message: "",
  type: "danger",
  insert: "top",
  container: "top-center",
  animationIn: ["animated", "flipInY"],
  animationOut: ["animated", "bounceOut"],
  dismiss: {
    duration: 10000,
    onScreen: false,
    showIcon: true,
  },
};

export const sessionNotification = {
  title: "Session Error!",
  message: "",
  type: "danger",
  insert: "top",
  container: "top-center",
  animationIn: ["animated", "flipInY"],
  animationOut: ["animated", "bounceOut"],
  dismiss: {
    duration: 10000,
    onScreen: false,
    showIcon: true,
  },
};

export const success = (message, notification, useContent = false) => {
  store.addNotification({
    ...notification,
    [useContent ? "content" : "message"]: message,
  });
};

export const warning = (message, notification) => {
  store.addNotification({
    ...notification,
    message: message,
  });
};

export const info = (message, notification) => {
  setTimeout(() => {
    store.addNotification({
      ...notification,
      message: message,
    });
  }, 10000);
};
export const info1 = (message, notification) => {
  setTimeout(() => {
    store.addNotification({
      ...notification,
      message: message,
    });
  }, 10000);
};

export const info2 = (message, notification) => {
  setTimeout(() => {
    store.addNotification({
      ...notification,
      message: message,
    });
  }, 10000);
};
export const info3 = (content, notification) => {
  setTimeout(() => {
    store.addNotification({
      ...notification,
      content: content,
    });
  }, 10000);
};
export const info4 = (content, notification) => {
  setTimeout(() => {
    store.addNotification({
      ...notification,
      content: content,
    });
  }, 10000);
};
export const error = (message, notification) => {
  store.addNotification({
    ...notification,
    message: message,
  });
};

export const sessionerror = (message, notification) => {
  store.addNotification({
    ...notification,
    message: message,
  });
};
